import * as firebase from 'firebase';
import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'

@Injectable()

export class AuthService {
	public fireAuth: any;
	public userProfile: any;
	public imageURL:any;
	userProfileModerator:any;
	constructor(){
	  this.fireAuth= firebase.auth();
	  this.userProfile = firebase.database().ref('users');
	  this.userProfileModerator = firebase.database().ref('moderator');
	}
    registerSP(email: string, password: string) {
        firebase.auth()
        .createUserWithEmailAndPassword(email, password).then((authenticatedUser) => {
		
		console.log("User Login Account Created");
		
		});
       
    }
	 registerRM(email: string, password: string,username:string) {
        firebase.auth()
        .createUserWithEmailAndPassword(email, password).then((authenticatedUser) => {
			this.userProfile.child(authenticatedUser.uid).set({			
			email:email,
			password:password,
			userType:"requestMaker",
			username:username
			//service:service
	
		});	
		
		});
       
	}

	register(user) {
		console.log(user);

   
	   firebase.auth()
	   .createUserWithEmailAndPassword(user.username, user.password).then((authenticatedUser) => {
		
		   this.userProfileModerator.child(authenticatedUser.uid).set({			
			firstname:user.firstname,
			lastname:user.lastname,
			primary_address:user.primary_address,
			city:user.city,
			state:user.state,
			zipcode:user.zipcode,
			status:user.status,
			role:user.role,
			username:user.username,
			password:user.password,
		   //service:service
   
	   });	
	   this.addImage(this.userProfileModerator,authenticatedUser.uid);
	   });
	  
   }

	createAlert(message,alertType){

		Swal(message,alertType);

	}

	addImage(refURL,key){
	  
	  

		let base=this
		// base.LimagesectionupdateSuccess = true
		 var fileButton = (<HTMLInputElement>document.getElementById("bannerimage"));
		 var file = fileButton.files[0];
		 var d = new Date();
		 var n = d.getTime();
		 let imageName = n+'_Rx.jpg';  
		 var storageRef = firebase.storage().ref('assets1/'+imageName);
		// base.count=1;
		// base.printSome();
		
		 storageRef.put(file).then(()=>{
			var returnVal;
		   storageRef.getDownloadURL().then(function(url) {
			refURL.child(key).update({
				imageurl:url,
			
			   })
			// ;
		   })
		 })
		  
		 return this.imageURL;
	  }

    login(email: string, password: string){
     return   firebase.auth().signInWithEmailAndPassword(email, password);
    
    }
	
	 viewUser(userId:any)
 {
	 var userRef=this.userProfile.child(userId)
	 return userRef.once('value');
 }
}
